export class AuthTokenModel {
    token: string;
    tokenExpirationUtc: Date;
}
